import { FC } from "react";

import Image from "next/legacy/image";

import Box from "@mui/material/Box";

import GridItem from "components/Grid/GridItem";

import styles from "./styles";

interface NoItemsProps {
  children: JSX.Element | JSX.Element[];
}

const NoItems: FC<NoItemsProps> = ({ children }) => {
  return (
    <GridItem xs={12}>
      <Box sx={styles.wrapper}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/common/no-items.png`}
          alt="no items"
          width="420"
          height="233"
          style={{ marginBottom: 16 }}
        />
        {children}
      </Box>
    </GridItem>
  );
};

export default NoItems;
